import { render, staticRenderFns } from "./AboutMetro.vue?vue&type=template&id=e0d03a84&"
import script from "./AboutMetro.vue?vue&type=script&lang=js&"
export * from "./AboutMetro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports